import tracking from './trackingSetup';
import invalidateMagentoCache from './invalidateMagentoCache';
import saveInAddressBook from './saveInAddressBook';

const StorePlugins = [tracking, invalidateMagentoCache, saveInAddressBook];

export default StorePlugins;
